// src/components/image-link-grid-list/image-link-grid-list.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CrossLinkContainerFragment on CrossLinksContainer {\n    header\n    subheader\n    description\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ImageLinkFragment on EGDSImageLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n      useRelativePath\n    }\n    image {\n      ...ImageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ImageLinkCardFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...ImageLinkFragment\n    }\n    title\n    gaiaId: egdsElementId\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CrossLinkGridFragment on CrossLinkGrid {\n    links {\n      ...ImageLinkCardFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  query ImageLinkGridListQuery(\n    $strategyName: String!\n    $context: ContextInput!\n    $uriContext: UriContextInput!\n    $parameters: [CrossLinksParameterInput!]\n    $limit: Int!\n  ) {\n    crosslinks(context: $context, limit: $limit, strategyName: $strategyName, uriContext: $uriContext, parameters: $parameters) {\n      ...CrossLinkContainerFragment\n      grid {\n        ...CrossLinkGridFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React6 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/crosslink-container/crosslink-container.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkCard } from "uitk-react-cards";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkParagraph, UitkSubheading } from "uitk-react-text";
var fragment = gql(_templateObject());
var CrossLinkContainer = function(props) {
    var data = props.data, children = props.children;
    var header = data.header, subheader = data.subheader, description = data.description;
    return /* @__PURE__ */ React.createElement(UitkCard, {
        padded: true
    }, header && /* @__PURE__ */ React.createElement(UitkHeading, {
        size: 6,
        tag: "h3"
    }, header), subheader && /* @__PURE__ */ React.createElement(UitkSubheading, {
        tag: "p"
    }, subheader), description && /* @__PURE__ */ React.createElement(UitkParagraph, {
        size: 3
    }, description), /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "three"
    }, children));
};
CrossLinkContainer.fragment = fragment;
CrossLinkContainer.displayName = "CrossLinkContainer";
// src/components/image-link-grid-list/__private/__fragments/cross-link-grid.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/crosslinks-text-and-image-links/cross-links-image-link-card.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker2, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard2, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkPill } from "uitk-react-pill";
import { UitkHeading as UitkHeading2, UitkSubheading as UitkSubheading2 } from "uitk-react-text";
// ../internal/src/components/tracking/clickstream-utils.ts
var clickstreamEventBuilder = function(clickStreamEventConstants) {
    return {
        event: {
            event_type: clickStreamEventConstants.EVENT_TYPE,
            event_name: clickStreamEventConstants.EVENT_NAME,
            event_version: clickStreamEventConstants.EVENT_VERSION
        }
    };
};
// ../internal/src/components/tracking/clickstream-constants.ts
var DESTINATIONS_CAROUSEL_CARD_SELECTED_EVENT_CONSTANTS = {
    EVENT_NAME: "destinations_carousel_card.selected",
    EVENT_TYPE: "Interaction" /* INTERACTION */ ,
    EVENT_VERSION: "1.2.0"
};
var _obj;
// ../internal/src/components/crosslinks-text-and-image-links/__private/link-target.ts
var UILinkTargetMap = (_obj = {}, _defineProperty(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
// ../internal/src/components/crosslinks-text-and-image-links/cross-links-image.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
// ../internal/src/components/image/image.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// ../internal/src/components/image/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj1;
var aspectRatioMapper = (_obj1 = {}, _defineProperty(_obj1, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _defineProperty(_obj1, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _defineProperty(_obj1, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _defineProperty(_obj1, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _defineProperty(_obj1, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _defineProperty(_obj1, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _obj1);
// ../internal/src/components/image/image.tsx
var fragment2 = gql2(_templateObject1());
var Image = function(props) {
    var _props_data = props.data, aspectRatio = _props_data.aspectRatio, description = _props_data.description, url = _props_data.url;
    return /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R16_9
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: url,
        lazyLoading: "lazy"
    }));
};
Image.fragment = fragment2;
Image.displayName = "Image";
// ../internal/src/components/crosslinks-text-and-image-links/cross-links-image.tsx
var fragment3 = gql3(_templateObject2(), Image.fragment);
var ImageLink = function(props) {
    var data = props.data, _props_isLinkInsideOfTheCard = props.isLinkInsideOfTheCard, isLinkInsideOfTheCard = _props_isLinkInsideOfTheCard === void 0 ? true : _props_isLinkInsideOfTheCard;
    var image = data.image, action = data.action;
    var analytics = action.analytics, resource = action.resource, target = action.target;
    var clickTracker = useClickTracker();
    var onClickCapture = React3.useCallback(function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    if (data.__typename === "EGDSImageLink") {
        if (isLinkInsideOfTheCard) {
            return /* @__PURE__ */ React3.createElement(Image, {
                data: image
            });
        }
        return /* @__PURE__ */ React3.createElement(UitkLink, {
            onClickCapture: onClickCapture
        }, /* @__PURE__ */ React3.createElement("a", {
            href: resource.value,
            target: target
        }, /* @__PURE__ */ React3.createElement(Image, {
            data: image
        })));
    }
    return null;
};
ImageLink.fragment = fragment3;
ImageLink.displayName = "ImageLinkCard";
// ../internal/src/components/crosslinks-text-and-image-links/cross-links-image-link-card.tsx
var overlayLayout = {
    top: "zero",
    right: "zero",
    bottom: "zero",
    left: "zero"
};
var fragment4 = gql4(_templateObject3(), ImageLink.fragment);
var ImageLinkCard = function(props) {
    var data = props.data, padded = props.padded, border = props.border, selected = props.selected, _props_headingTag = props.headingTag, headingTag = _props_headingTag === void 0 ? "h6" : _props_headingTag, onSelect = props.onSelect, onDeselect = props.onDeselect, _props_featuredLocationsVersion = props.featuredLocationsVersion, featuredLocationsVersion = _props_featuredLocationsVersion === void 0 ? false : _props_featuredLocationsVersion;
    var title = data.title, link = data.link, subTitle = data.subTitle, description = data.description;
    var action = link.action;
    var clickTracker = useClickTracker2();
    var track = useEgClickstream();
    var publishClickstreamEvent = function(clickstreamEventConstants) {
        var clickstreamEvent = clickstreamEventBuilder(clickstreamEventConstants);
        track(clickstreamEvent);
    };
    var onClickCapture = React4.useCallback(function() {
        clickTracker(action.analytics.referrerId, action.analytics.linkName);
        publishClickstreamEvent(DESTINATIONS_CAROUSEL_CARD_SELECTED_EVENT_CONSTANTS);
    }, [
        action.analytics.linkName,
        action.analytics.referrerId,
        clickTracker
    ]);
    return /* @__PURE__ */ React4.createElement(UitkCard2, {
        padded: padded,
        border: border,
        selected: selected
    }, /* @__PURE__ */ React4.createElement(UitkCardLink, null, /* @__PURE__ */ React4.createElement("a", {
        target: UILinkTargetMap[action.target],
        href: link.action.resource.value,
        onClickCapture: onClickCapture,
        onMouseEnter: onSelect,
        onMouseLeave: onDeselect
    }, action.accessibility)), /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React4.createElement(ImageLink, {
        data: link
    }), featuredLocationsVersion && /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: overlayLayout,
        cloneElement: true,
        "aria-hidden": true
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        alignItems: "center",
        justifyContent: "center"
    }, description && /* @__PURE__ */ React4.createElement(UitkPill, {
        id: "imageLinkCard-pill-description",
        altText: description
    }, description)))), /* @__PURE__ */ React4.createElement(UitkCardContentSection, null, title && /* @__PURE__ */ React4.createElement(UitkHeading2, {
        tag: headingTag,
        overflow: "truncate"
    }, title), featuredLocationsVersion ? subTitle && /* @__PURE__ */ React4.createElement(UitkSubheading2, null, " ", subTitle, " ") : description && /* @__PURE__ */ React4.createElement(UitkSubheading2, null, description)));
};
ImageLinkCard.fragment = fragment4;
ImageLinkCard.displayName = "ImageLinkCard";
// src/components/image-link-grid-list/__private/__fragments/cross-link-grid.tsx
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
var fragment5 = gql5(_templateObject4(), ImageLinkCard.fragment);
var CrossLinkGrid = function(props) {
    var data = props.data, columns = props.columns;
    var links = data.links;
    var cards = links.map(function(card, ind) {
        if (card.__typename === "EGDSImageLinkCard") {
            return /* @__PURE__ */ React5.createElement(UitkLayoutGridItem, {
                key: ind
            }, /* @__PURE__ */ React5.createElement(ImageLinkCard, {
                data: card
            }));
        }
        return null;
    }).filter(function(card) {
        return card;
    });
    return /* @__PURE__ */ React5.createElement(UitkLayoutGrid, {
        columns: columns,
        space: "two",
        "data-stid": "layoutgrid"
    }, cards);
};
CrossLinkGrid.fragment = fragment5;
CrossLinkGrid.displayName = "CrossLinkGrid";
// src/components/image-link-grid-list/image-link-grid-list.tsx
var __Query = gql6(_templateObject5(), CrossLinkContainer.fragment, CrossLinkGrid.fragment);
var ImageLinkGridList = function(props) {
    var _data_crosslinks, _data_crosslinks_grid;
    var inputs = props.inputs, skipSsr = props.skipSsr, columns = props.columns;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || (data === null || data === void 0 ? void 0 : (_data_crosslinks = data.crosslinks) === null || _data_crosslinks === void 0 ? void 0 : (_data_crosslinks_grid = _data_crosslinks.grid) === null || _data_crosslinks_grid === void 0 ? void 0 : _data_crosslinks_grid.__typename) !== "CrossLinkGrid") {
        return null;
    }
    return /* @__PURE__ */ React6.createElement(CrossLinkContainer, {
        data: data.crosslinks
    }, /* @__PURE__ */ React6.createElement(CrossLinkGrid, {
        data: data.crosslinks.grid,
        columns: columns !== null && columns !== void 0 ? columns : 4
    }));
};
ImageLinkGridList.displayName = "ImageLinkGridList";
export { ImageLinkGridList };
//# sourceMappingURL=index.js.map